import * as types from './action-types';
import state from './state';

let initialState = state;

export default (state = initialState, action) => {
  let _obj;
  switch (action.type) {
    case types.SET_TICKET_DATA:
      _obj = state[action.payload.key];
      _obj = action.payload.data;
      return {
        ...state,
        [action.payload.key]: [..._obj]
      };
    case types.SET_SINGLE_TICKET_DATA:
      if (action.payload.key && action.payload.data) {
        _obj = state[action.payload.key];
        _obj = action.payload.data;
        return {
          ...state,
          [action.payload.key]: { ..._obj }
        };
      };
      break;
    case types.ADD_TICKET_DATA:
      _obj = state[action.payload.key];
      _obj = action.payload.data.model;
      return {
        ...state,
        [action.payload.key]: { ..._obj }
      };
    case types.DELETE_TICKET_DATA:
      _obj = state[action.payload.key];
      return {
        ...state,
        [action.payload.key]: [..._obj]
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ticket/reducers.js